import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c530c7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "zero_item",
  "data-test": "zero-item"
}
const _hoisted_2 = { class: "title_l" }

import SimpleButton from '@/components/atoms/SimpleButton'



export default /*#__PURE__*/_defineComponent({
  __name: 'ZeroItem',
  emits: ["clear"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('zero_item.no_matching_camera')), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('zero_item.change_search')), 1),
    _createVNode(_unref(SimpleButton), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear'))),
      color: "color-primary",
      size: "size-m",
      "data-test": "clear-zero-item"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('zero_item.clear_condition')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})